/**
 * Handy tool for generating arrays of numbers with different intervals. See examples.
 *
 * Example 1:
 * < fillRange([{ before: 1000, increment: 200 }])
 * > [200, 400, 600, 800, 1000]
 *
 * Example 2:
 * < fillRange([{ before: 1000, increment: 200 }, { before: 3000, increment: 500 }])
 * > [200, 400, 600, 800, 1000, 1500, 2000, 2500, 3000]
 */
const fillRange = points => {
  const res = []
  let current = 0
  points.forEach(({ before, increment }) => {
    while (current + increment <= before) {
      current += increment
      res.push(current)
    }
  })
  return res
}

export const rentPerMonth = fillRange([
  { before: 4000, increment: 200 },
  { before: 10000, increment: 500 },
  { before: 30000, increment: 2500 },
  { before: 50000, increment: 10000 },
])

export const rentPerSqm = fillRange([
  { before: 200, increment: 20 },
  { before: 1000, increment: 50 },
  { before: 2000, increment: 100 },
  { before: 3000, increment: 250 },
])

export const buyBudget = fillRange([
  { before: 100000, increment: 10000 },
  { before: 500000, increment: 50000 },
  { before: 1000000, increment: 100000 },
  { before: 2000000, increment: 250000 },
  { before: 10000000, increment: 500000 },
  { before: 20000000, increment: 5000000 },
])

export const surface = fillRange([
  { before: 50, increment: 10 },
  { before: 500, increment: 50 },
  { before: 1000, increment: 100 },
  { before: 5000, increment: 500 },
])
